"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgVKLimitLogo = function SvgVKLimitLogo(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21.54 6.867c.141-.464 0-.805-.66-.805h-2.188c-.557 0-.812.295-.952.618 0 0-1.113 2.714-2.689 4.473-.509.512-.742.674-1.02.674-.139 0-.34-.162-.34-.626V6.867c0-.557-.16-.805-.624-.805h-3.44c-.347 0-.556.257-.556.504 0 .526.788.648.868 2.133v3.222c0 .705-.126.835-.406.835-.741 0-2.546-2.724-3.616-5.842-.209-.606-.42-.851-.978-.851H2.75c-.626 0-.751.295-.751.618 0 .58.742 3.455 3.454 7.257 1.809 2.596 4.355 4.003 6.674 4.003 1.391 0 1.563-.312 1.563-.851v-1.963c0-.624.131-.75.572-.75.324 0 .88.163 2.179 1.415 1.483 1.482 1.729 2.149 2.562 2.149h2.188c.625 0 .937-.313.758-.93-.197-.614-.906-1.507-1.846-2.564-.51-.603-1.275-1.252-1.507-1.576-.325-.419-.23-.603 0-.974 0 0 2.667-3.754 2.944-5.03Z",
    fill: "#2F8AF2"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgVKLimitLogo);
var _default = exports["default"] = Memo;